import type { GetPersonaNotesResponse } from '../../../../service';
export function convertNotes(response: GetPersonaNotesResponse): string[] {
    return response.PersonaWithNotes
        ? response.PersonaWithNotes.BodiesArray.map(note => note.Value.Value)
        : [];
}
